// ~/components/Snackbar.vue

<template>
  <v-snackbar
    v-model="show"
    :color="color"
    :timeout="1500"
    :max-width="200"
    :min-width="200"
    shaped
    top
    right
    rounded-xl
  >
    {{ message }}
    <!-- <v-btn text @click="show = false">X</v-btn> -->
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      color: "",
    };
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "showMessage") {
        this.message = state.content;
        this.color = state.color;
        this.show = true;
      }
    });
  },
};
</script>